import { postUsersMeV2OrganisationsCurrentByTypeResourcesSelector } from "./postUsersMeV2OrganisationsCurrentByTypeResourcesSelector";
import { postUsersMeOrganisationsCurrentK8SByTypeResourcesSelector } from "./postUsersMeOrganisationsCurrentK8SByTypeResourcesSelector";
import { getResourceGridDataFixedCacheKey } from "../../utils/helpers/fixedCacheKeys";
import { RootState } from "@/store/store";

export const gridResourceDataLoadingSelector = (
  state: RootState,
  masterGridId: string,
) => {
  const providersLoading =
    postUsersMeV2OrganisationsCurrentByTypeResourcesSelector(
      getResourceGridDataFixedCacheKey(masterGridId),
    )(state)?.isLoading;

  const k8sLoading = postUsersMeOrganisationsCurrentK8SByTypeResourcesSelector(
    getResourceGridDataFixedCacheKey(masterGridId),
  )(state)?.isLoading;

  return !!(k8sLoading || providersLoading);
};
